const swiperExplore = new Swiper('.swiper-explore', {
      slidesPerView: 2,
      slidesPerGroup: 2,

      spaceBetween: 10,
      loop:true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next-explore',
        prevEl: '.swiper-button-prev-explore',
      },
      pagination: {
        el: '.swiper-pagination-explore',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 24
        },
        900: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 24
        }
      }
    });
  